const i18nextResources = {
  "ar": {
    "translation": {
      "DHIS 2 browser cache cleaner": "منظف ذاكرة التخزين المؤقت لمتصفح DHIS2",
      "Session storage": "تخزين الجلسة",
      "Local storage": "التخزين المحلي",
      "indexedDB": "indexedDB",
      "Clear": "مسح",
      "Clearing cache": "جار تنظيف ذاكرة التخزين المؤقت",
      "Are you sure you want to proceed with the cleaning?": "هل تريد بالتأكيد المتابعة في التنظيف؟",
      "Cancel": "إلغاء",
      "Proceed": "متابعة"
    }
  },
  "ckb": {
    "translation": {
      "DHIS 2 browser cache cleaner": "باكردنةوةي زيادةي براوسيري دي اج اي اس 2",
      "Session storage": "كوكردنةوي كويوونةوة",
      "Local storage": "كؤكردنةوةي ناوخؤيي",
      "indexedDB": "ثيوانة",
      "Clear": "باك",
      "Clearing cache": "باكردنةوةي زيادةكان",
      "Are you sure you want to proceed with the cleaning?": "دلنايي ئةتةويت باكردنةوة ئةنجام بدةيت ؟ ",
      "Cancel": "لابردن",
      "Proceed": "ئةنجام دان"
    }
  },
  "es": {
    "translation": {
      "DHIS 2 browser cache cleaner": "DHIS 2 limpiador de la caché del navegador",
      "Session storage": "Almacenamiento de la sesión",
      "Local storage": "Almacenamiento local",
      "indexedDB": "BD indexada",
      "Clear": "Limpiar",
      "Clearing cache": "Borrando caché",
      "Are you sure you want to proceed with the cleaning?": "¿Estás seguro de que quieres proseguir con el borrado?",
      "Cancel": "Cancelar",
      "Proceed": "Proceder"
    }
  },
  "fr": {
    "translation": {
      "DHIS 2 browser cache cleaner": "Videur du cache navigateur DHIS2",
      "Session storage": "Stockate de session",
      "Local storage": "Stockage local",
      "indexedDB": "IndexedDB",
      "Clear": "Effacer",
      "Clearing cache": "Vidange du cache",
      "Are you sure you want to proceed with the cleaning?": "Êtes-vous sûr de vouloir procéder au nettoyage ?",
      "Cancel": "Annuler",
      "Proceed": "Poursuivre"
    }
  },
  "id": {
    "translation": {
      "DHIS 2 browser cache cleaner": "DHIS 2 browser cache cleaner",
      "Session storage": "Session Storage",
      "Local storage": "Local Storage",
      "indexedDB": "IndexedDB",
      "Clear": "Hapus",
      "Clearing cache": "Bersihkan cache",
      "Are you sure you want to proceed with the cleaning?": "Apakah anda yakin untuk melanjutkan proses cleaning?",
      "Cancel": "Batal",
      "Proceed": "Lanjutkan"
    }
  },
  "lo": {
    "translation": {
      "Home": "ໜ້າຫຼັກ",
      "Profile": "ໂປຟາຍ",
      "Apps": "ແອບ",
      "More apps": "ແອບເພີ້ມເຕີມ",
      "Search apps": "ຊອກຫາ",
      "Settings": "ການຕັ້ງຄ່າ",
      "Account": "ບັນຊີ",
      "Log out": "ອອກຈາກລະບົບ",
      "About DHIS 2": "ກ່ຽວກັບ DHIS 2",
      "DHIS 2 browser cache cleaner": "ລ້າງຂໍ້ມູນຂອງ DHIS 2 ໃນເຄດລອງບາວເຊີ້",
      "This clears the selected items from your browser cache": "ມັນຂະລ້າງຂໍ້ມູນໃນບາວເຊີ້ທັງໝົດ",
      "Are you sure you want to proceed with the cleaning?": "ເຈົ້າຕ້ອງການລ້າງຂໍ້ມູນນີ້ອອກຈາກບາວເຊີ້ແທ້ບໍ?",
      "Browser cache is cleared.": "ຂໍ້ມູນໃນບາວເຊີ້ຖືກລ້າງແລ້ວ",
      "Browser cache is empty. Nothing to clear.": "ບໍ່ມີຂໍ້ມູນໃນຄວາມຈຳຂອງບາວເຊີ້",
      "Clearing cache": "ລ້າງຂໍ້ມູນ",
      "Proceed": "ດຳເນີນ",
      "Select all": "ເລືອກທັງໝົດ",
      "Unselect all": "ບໍ່ເລືອກທັງໝົດ",
      "Cancel": "ຍົກເລີກ",
      "Clear": "ລ້າງ"
    }
  },
  "prs": {
    "translation": {
      "DHIS 2 browser cache cleaner": "پاک کننده حافظه بروزر DHIS 2",
      "Session storage": "ذخیر کردن سیشن",
      "Local storage": "ذخیره سازی داخلی",
      "indexedDB": "IndexedDB",
      "Clear": "پاک کردن",
      "Clearing cache": "پاک سازی حافظه بروزر",
      "Are you sure you want to proceed with the cleaning?": "آیا شما مطمین هستید با انجام پاک سازی؟",
      "Cancel": "انصراف",
      "Proceed": "اقدام کردن"
    }
  },
  "ps": {
    "translation": {
      "DHIS 2 browser cache cleaner": "د DHIS 2 په لټوونکي کې د ثبت پاکوونکی ",
      "Session storage": "د ناستې د جریان زېرمه کول",
      "Local storage": "ځایي زېرمه کول",
      "indexedDB": "په انټرنیټي جدول کې درجول (IndexedDB)",
      "Clear": "پاک یې کړئ",
      "Clearing cache": "ساتنځای د پاکولو په حال کې دی",
      "Are you sure you want to proceed with the cleaning?": "آیا د پاکولو بهیر ته د دوام ورکولو په برخه کې ډاډه یاست؟",
      "Cancel": "پاک یې کړئ",
      "Proceed": "دوام ورکول"
    }
  },
  "pt": {
    "translation": {
      "DHIS 2 browser cache cleaner": "Limpador do cache do navegador do DHIS 2",
      "Session storage": "Armazenamento da sessão",
      "Local storage": "Armazenamento local",
      "indexedDB": "Base de dados indexada",
      "Clear": "Limpar",
      "Clearing cache": "Esvaziando o cache",
      "Are you sure you want to proceed with the cleaning?": "Deseja prosseguir com a limpeza?",
      "Cancel": "Cancelar",
      "Proceed": "Prosseguir"
    }
  },
  "sv": {
    "translation": {
      "Home": "Hem",
      "DHIS 2": "DHIS2",
      "DHIS 2 Home": "DHIS 2 Hem",
      "Profile": "Profil",
      "Apps": "Appar",
      "More apps": "Mer appar",
      "Search apps": "Sök appar",
      "Settings": "Inst",
      "Account": "Konto",
      "Log out": "Logga ut",
      "About DHIS 2": "Om DHIS 2",
      "Session Storage": "Session lagring",
      "Local Storage": "Lokal lagring",
      "IndexedDB": "IndexedDB",
      "DHIS 2 browser cache cleaner": "DHIS2 webbläsare cache rengörare",
      "This clears selected items from your browser cache": "Detta rensar valda objekt från din webbläsarens cache",
      "Are your sure you want to proceed with the cleaning?": "Är du säkert du vil forstätta med rensning?",
      "Browser cache is cleared.": "Webbläsarens cache har rensats.",
      "Browser cache is empty. Nothing to clear.": "Webbläsarens cache är tomt. Inget att rensa.",
      "Clearing cache": "Rensa cacheminnet",
      "Proceed": "Fortsätta",
      "Select all": "Välj alla",
      "Unselect all": "Ta bort alla",
      "Cancel": "Annulera",
      "Clear": "Ta bort"
    }
  },
  "ur": {
    "translation": {
      "DHIS 2 browser cache cleaner": "DHIS 2 براؤزر کیش کلینر",
      "Session storage": "سیشن اسٹوریج",
      "Local storage": "مقامی ذخیرہ",
      "indexedDB": "انڈیکس شدہ ڈی بی",
      "Clear": "واضح کریں",
      "Clearing cache": "صاف کرنے کیشے",
      "Are you sure you want to proceed with the cleaning?": "کیا آپ واقعی صفائی کے ساتھ آگے بڑھنا چاہتے ہیں؟",
      "Cancel": "منسوخ کریں",
      "Proceed": "آگے بڑھو"
    }
  },
  "vi": {
    "translation": {
      "DHIS 2 browser cache cleaner": "Trình xóa dữ liệu cục bộ trong DHIS 2",
      "Session storage": "Lưu trữ phiên",
      "Local storage": "Lưu trữ cục bộ",
      "indexedDB": "Chỉ mục cơ sở dữ liệu",
      "Clear": "Xóa",
      "Clearing cache": "Đang xóa...",
      "Are you sure you want to proceed with the cleaning?": "Bạn có chắc chắn muốn thực thi việc xóa dữ liệu cục bộ?",
      "Cancel": "Hủy",
      "Proceed": "Thực hiện"
    }
  }
}; export default i18nextResources;


// WEBPACK FOOTER //
// ./i18n/resources.js